import React, { Fragment } from 'react'
import { useTranslation } from 'react-i18next';
import { Breadcrumbs, UL } from '../../../../AbstractElements';
import AuditDashboard from './AuditDashboard';
import { Container } from 'reactstrap';

const Audit = () => {
    const { t } = useTranslation();
    return (
        <UL attrUL={{ className: 'simple-list nav-menus flex-row' }}>
            <Fragment>
                <Breadcrumbs parent={t('Audit')} title={t('Audit')} mainTitle={t('Audit')} />
                <Container fluid={true}>
                    <AuditDashboard />
                </Container>
            </Fragment>
        </UL>
    )
}

export default Audit